// extracted by mini-css-extract-plugin
module.exports = {"grid":"SuccessModal_grid__2a4cM","button":"SuccessModal_button__eTah7","iconContainer":"SuccessModal_iconContainer__1TVa3"};